//tip.js
import Vue from "vue";
import Loading from "../components/Loading.vue";

let PromptConstructor = Vue.extend(Loading);
let instance;

const tip = function (a, b) {
  //删除旧dom
  const msgDom = document.getElementById("loadsss");
  if (msgDom) {
    document.body.removeChild(msgDom);
  }
  //接受参数
  const opt = {
    show: a,
    texts: b ? b : "",
  };
  //创建实例
  instance = new PromptConstructor({
    data: opt,
  });
  //渲染dom
  document.body.appendChild(instance.$mount().$el);
};

export default tip;
